import gql from 'graphql-tag';

export const GET_TEMPLATES = gql`
  query FlowTemplates($input: TemplatesInput!) {
    templates: businessProcessFlowTemplates(input: $input) {
      department {
        id
        name
      }
      templates {
        name
        accountId
        businessProcessFlowId
        department {
          id
          name
        }
        stages {
          name
          ordinal
          stageFields
          completionRules
          businessProcessFlowId
          businessProcessFlowStageId
        }
      }
    }
  }
`;
